"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasBoxPrintableOption;
function hasBoxPrintableOption(options) {
  return !!Object.keys(options).find(key => options[key].toLowerCase() === 'box' || options[key].toLowerCase() === 'walnut' || options[key].toLowerCase() === 'birch');
}